import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { userTokenPersistence, resourcePersistence } from 'persistence';
import { useCoreTableState } from 'state';
import AddInvestor from './subscriptions/AddInvestor';

const Signup = () => {
  const navigate = useNavigate();
  const userToken = userTokenPersistence.get();

  useEffect(() => {
    if (userToken) {
      navigate('/home');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userToken]);

  const { fetchOrganizations } = useCoreTableState();

  useEffect(() => {
    fetchOrganizations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const location = useLocation();

  useEffect(() => {
    const { search } = location;
    const params = new URLSearchParams(search);
    const tokenId = params.get('token-id');
    if (tokenId) {
      resourcePersistence.set('partnerPlatform:selectedTokenId', tokenId);
    }
  }, []);

  return <AddInvestor />;
};

export default Signup;
